let fxNodeEnv = 'production'
if (process.env.FX_IS_BUILD_TEST) {
	fxNodeEnv = 'test'
} else if (['production', 'test'].includes(process.env.NODE_ENV)) {
	fxNodeEnv = 'production'
} else {
	fxNodeEnv = 'development'
}

export const FX_NODE_ENV = fxNodeEnv



// WEBPACK FOOTER //
// ./src/configs/env.config.js